import { Component, input } from '@angular/core';
import { IFormatedServiceBudget } from '@core/interface';

@Component({
  selector: 'lib-card-display-items-budget',
  standalone: true,
  templateUrl: './card-display-items-budget.component.html',
  styleUrls: ['./card-display-items-budget.component.scss'],
})
export class CardDisplayItemsBudgetComponent {
  title = input.required<string>();
  taxLabel = input.required<string>();
  footerLabel = input<string>('Total');
  total = input<string>();

  items = input.required<Partial<IFormatedServiceBudget>[]>();
}
